export default "__VITE_PUBLIC_ASSET__0ae2034f__"